import { sanitizeUrl } from '@braintree/sanitize-url';

export type SanitizedUrl = string;

export const toSanitizedUrl = (url: string): SanitizedUrl => sanitizeUrl(url);
